import { useState, useEffect, memo } from 'react';
import { useDashboard } from "../../context/dashboardContext.js";
import { useAuth } from "../../context/loginContext.js";
import axiosAWS from '../../api/configAxios.js';
import Cookie from "js-cookie";
import ReactIframe from 'react-iframe';
import Swal from 'sweetalert2';

const Tablero = () => {

    const { apartados, get_url_params } = useDashboard();
    const { get_favoritos, favoritos, Loadfavoritos } = useAuth();
    const [urlTbl, setUrlTbl] = useState(null);
    const [inspeccion, setInspeccion] = useState(false);
    const [titulo_tablero, setTitulo] = useState("--- ---");
    const [cargaTbl, setCargaTbl] = useState(false);
    const [cargaIfav, setCargaIfav] = useState(false);
    const [favorite, setfavorite] = useState(false);


    const get_data_consulta = async (url, data) => {
        //console.log(data);
        var result = null;
        try {
            const cookies = Cookie.get();
            var result_auth = null;

            result_auth = await axiosAWS.post(url, data, { headers: { 'Authorization': `Bearer ${cookies.AutKeyPbi}` } }).catch(function (error) {
                if (error.response.status === 400) {
                    //console.log("error 400");
                }

                if (error.response.status >= 500) {
                    //console.log("algo anda mal con la el servidor");
                }
            });

            //console.log(result_auth);

            if (result_auth.status >= 200 || result_auth.status <= 299) {
                if (result_auth.data.hasOwnProperty("result")) {
                    if (result_auth.data.result !== null) {
                        result = result_auth.data.result;

                    } else {
                        alert("sin datos presentes");
                    }

                }

            } else {
                alert("usuario denegado");
            }

            return result;
        } catch (error) {

            //console.log("error servidorAWS");
            return "error";
        }
    }

    const get_tablero = async () => {
        setCargaTbl(true);
        setfavorite(false);
        var params = get_url_params();
        var params_tablero = params.split("|")[1];
        var params_Gtablero = params.split("|")[0];
        //validamos las cookies
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_tablero_online", "uuid_tablero": params_tablero, "uuid_Gtablero": params_Gtablero });
        result_tbl = result_tbl[0]
        //console.log(result_tbl);

        if (result_tbl.length === 0) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'Ups, algo salió mal. Inténtalo otra vez o comprueba el tablero que deseas visualizar',
                timer: 4000
            });
            setCargaTbl(false);
            setUrlTbl(null);
            //alert("Ups, algo salió mal. Inténtalo otra vez o comprueba el tablero que deseas visualizar")
            return
        }

        setTitulo(<>{result_tbl[0].Gtablero_titulo} - <b className='text-body-tertiary'>{result_tbl[0].tablero_titulo}</b></>);

        try {

            //validamos el tipo de URL para quitar o poner la tapa
            if ((result_tbl[0].url).includes("reportEmbed") || (result_tbl[0].url).includes(".cloudfront.net")) {
                document.getElementById("tap-set").style.display = "none";
            } else {
                document.getElementById("tap-set").style.display = "block";
            }

            // vamor agregar una fecha en la URL del link para forzar al navegador a recargar el cache
            var date_url = Date.now()

            if(!(result_tbl[0].url).includes("?")){
                setUrlTbl(result_tbl[0].url + "?refresh-che=" + date_url.toString());
            }else{
                setUrlTbl(result_tbl[0].url + "&refresh-che=" + date_url.toString());
            }

            
            //var fav_result = favoritos;
            //if (favoritos.length === 0) {
            var fav_result = await get_favoritos();
            //}
            for (let i_fav = 0; i_fav < fav_result.length; i_fav++) {
                const element = fav_result[i_fav];
                if (element.uuid_tablero === result_tbl[0].uuid_tablero) {
                    setfavorite(true);
                }
            }
        } catch (error) {
            setUrlTbl(null);
        }
        setCargaTbl(false);

    }

    const insert_fovorito = async (e) => {

        var params = get_url_params();
        params = params.split("|")[1];
        setCargaIfav(true)
        var result_insert = await get_data_consulta("panel-control/add-element/", { uuid_tablero: params, type: "Tfavorito" });

        //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'Existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setCargaIfav(false)
            return
        }

        if (!result_insert.hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'Existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setCargaIfav(false)
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Agregado a favoritos',
            timer: 4000
        });

        //alert("Agregado a favoritos");
        setfavorite(true)

        //console.log(result_insert)
    }



    useEffect(() => {
        get_tablero();

        //detectar salida de la pagina
        window.addEventListener('blur', function () {
            //setInspeccion(true);
            //console.log("desactivada");
        });

        window.addEventListener('focus', function () {
            setInspeccion(false);
            //console.log("activa");
        });

        /*
                document.addEventListener('visibilitychange', function () {
                    if (document.visibilityState === 'visible') {
                       //console.log('El usuario ha vuelto a la página');
                    } else {
                       //console.log('El usuario ha dejado de ver la página');
                    }
                });
                */

        //$('#popoverExample').popover();

    }, [apartados]);

    const imprimirPaginaCompleta = () => {
        window.print();
    };



    //retornamos "la vista"
    return (
        <div
            className="bg-dark-subtle d-flex flex-column"
            style={{
                height: "calc(100vh - 57px)", // altura navbar
            }}
        >

            {/* CABECERA */}
            <div className="flex-shrink-0">
                <div className="px-4 pt-3 pb-2">

                    <div className="row align-items-center">

                        <div className="col-md-10">
                            <label className="text-title-001">
                                {titulo_tablero}
                            </label>
                        </div>

                        <div className="col-md-2 text-end">

                            {
                                favorite
                                    ?
                                    <i className="bi bi-star-fill"></i>
                                    :
                                    cargaTbl
                                        ?
                                        <i className="bi bi-cloud-download-fill"></i>
                                        :
                                        <button
                                            className='btn btn-outline-dark btn-sm'
                                            onClick={() => insert_fovorito()}
                                            disabled={cargaIfav}
                                        >
                                            {
                                                cargaIfav
                                                    ? <>Cargando...</>
                                                    : <>
                                                        <i className="bi bi-star-fill"></i>
                                                        {" "}Agregar a favoritos
                                                    </>
                                            }
                                        </button>
                            }
                            <button
                                className='btn btn-outline-primary btn-sm ms-1'
                                onClick={() => imprimirPaginaCompleta()}
                            >
                                <i className="bi bi-printer"></i>
                            </button>

                        </div>

                    </div>

                </div>
            </div>

            {/* CONTENEDOR DEL IFRAME */}
            <div className="flex-grow-1 p-2 overflow-hidden">

                <div className="card h-100">

                    <div className="card-body h-100 p-0 position-relative seccion-imprimible">

                        {
                            !cargaTbl
                                ?
                                urlTbl !== null
                                    ?
                                    <iframe
                                        id="frame-PBI"
                                        src={urlTbl}
                                        title="PowerBI"
                                        className="w-100 h-100 border-0"
                                    />
                                    :
                                    <div className="h-100 d-flex justify-content-center align-items-center">
                                        <label className="text-title-001">
                                            Sin acceso
                                        </label>
                                    </div>
                                :
                                <div className="h-100 d-flex flex-column justify-content-center align-items-center">
                                    <img
                                        title="actividad"
                                        src="./img/progress-unscreen.gif"
                                        alt=""
                                        width="200"
                                    />

                                    <label className="text-title-001 mt-3">
                                        Cargando...
                                    </label>
                                </div>
                        }

                        <div id='tap-set' className='tapa bg-body-secondary'></div>

                    </div>

                </div>

            </div>

        </div>



    );
}

export default memo(Tablero);

